<template>
    <div>
        <VueECharts :option="reactiveChartOptions" style="width: 100%; height: 300px" class="chart"></VueECharts>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    data: {
        type: Object,
        default: {},
    },
});

const generateChartOptions = (data) => {
    const options = {
        grid: {
            left: '0.2%',
            right: '0.2%',
            bottom: '0.2%',
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                animation: false,
            },
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data?.xAxis,
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: data?.series,
                type: 'bar',
                itemStyle: {
                    borderRadius: 8,
                },
            },
        ],
    };

    // console.log(options);

    return options;
};
const reactiveChartOptions = ref(generateChartOptions(props.data));

watch(
    () => props.data,
    (newData) => {
        reactiveChartOptions.value = generateChartOptions(newData);
    }
);
</script>

<style scoped>
.chart {}
</style>
